module.exports = __webpack_public_path__ + "static/img/person.aeba097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person.png
// module id = hWso
// module chunks = 1